import { create } from 'zustand';
import type { BenefitPaymentType } from '@/features/shop-insurance/types';

export type BenefitPaymentTypeFilter = BenefitPaymentType | 'all';

interface BenefitTypeFilterState {
  selectedBenefitPaymentType: BenefitPaymentTypeFilter;
  actions: {
    setSelectedBenefitPaymentType: (value: BenefitPaymentTypeFilter) => void;
  };
}

export const useBenefitTypeFilterStore = create<BenefitTypeFilterState>(set => ({
  selectedBenefitPaymentType: 'all',
  actions: {
    setSelectedBenefitPaymentType: value => set({ selectedBenefitPaymentType: value }),
  },
}));

export const useSelectedBenefitPaymentType = () =>
  useBenefitTypeFilterStore(state => state.selectedBenefitPaymentType);

export const useBenefitTypeFilterActions = () =>
  useBenefitTypeFilterStore(state => state.actions);
